<template>
  <div class="flex-1 relative">
    <div
      class="flex items-center justify-between gap-2 px-3 py-2.5 border rounded-lg bg-white text-sm font-medium cursor-pointer"
      :class="open ? 'border-primary-400' : 'border-gray-200'"
      @click="open = !open"
    >
      <span>{{ modelValue }}</span>
      <i class="pi pi-chevron-down text-[10px] text-gray-400" />
    </div>
    <template v-if="open">
      <!-- click-away -->
      <div class="fixed inset-0 z-10" @click="open = false" />
      <div class="absolute top-full inset-x-0 z-20 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-[180px] overflow-y-auto p-1">
        <div
          v-for="t in options"
          :key="t"
          class="px-2.5 py-2 rounded-md text-[13px] text-center cursor-pointer"
          :class="t === modelValue ? 'bg-primary-100 text-primary-700 font-semibold' : 'text-gray-700 active:bg-gray-50'"
          @click="pick(t)"
        >{{ t }}</div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

defineProps<{ modelValue: string; options: string[] }>();
const emit = defineEmits<{ 'update:modelValue': [v: string] }>();

const open = ref(false);
const pick = (t: string) => {
  emit('update:modelValue', t);
  open.value = false;
};
</script>
